<template>
  <th
    class="text-center justify-content-center"
    :class="{ 'bg-light': rows_selected > 0 }"
  >
    <p-check
      v-model="allRowsSelected_"
      class="p-icon"
      color="primary"
      :indeterminate="showIndeterminateState"
      @change="cb_change"
    >
      <template #extra>
        <i class="icon far fa-check" />
      </template>
      <template #indeterminate-extra>
        <i class="icon far fa-minus text-primary" />
      </template>
    </p-check>
  </th>
</template>

<script>
export default {
  name: 'SelectAllRowsCheckBox',
  props: {
    allRowsSelected: {
      type: Boolean,
      default: false,
    },
    currentPageSelectionCount: {
      type: Number,
      default: 0,
    },
    rows_selected: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data: function () {
    return {
      allRowsSelected_: false,
    }
  },
  computed: {
    showIndeterminateState() {
      return !this.allRowsSelected && this.currentPageSelectionCount > 0
    },
  },
  watch: {
    allRowsSelected(val) {
      this.allRowsSelected_ = val
    },
  },
  mounted() {
    this.allRowsSelected_ = this.allRowsSelected
  },
  methods: {
    cb_change() {
      this.$emit('select-all-row-checkbox')
      this.allRowsSelected_ = false
    },
  },
}
</script>

<style scoped>
.custom-control-label {
  vertical-align: top;
}
</style>
